/*
	comment: 行业类别数据
*/
const industryList = [
	[
		{
			id: '0',
			name: '无'
		},
		{
			id: '269',
			name: '房地产/物业管理'
		},
		{
			id: '253',
			name: '保险'
		},
		{
			id: '251',
			name: '财务/审计'
		},
		{
			id: '252',
			name: '金融/银行'
		},
		{
			id: '295',
			name: '信托/拍卖'
		},
		{
			id: '275',
			name: '教育/科研/培训'
		},
		{
			id: '272',
			name: '中介/专业服务'
		},
		{
			id: '3527',
			name: '人力资源服务'
		},
		{
			id: '262',
			name: '医疗/保健/卫生/美容'
		},
		{
			id: '277',
			name: '娱乐休闲/餐饮/服务'
		},
		{
			id: '276',
			name: '旅游/酒店'
		},
		{
			id: '278',
			name: '交通/运输/物流'
		},
		{
			id: '261',
			name: '汽车/摩托车'
		},
		{
			id: '244',
			name: '互联网/电子商务'
		},
		{
			id: '245',
			name: '计算机软件'
		},
		{
			id: '246',
			name: '计算机硬件'
		},
		{
			id: '291',
			name: '游戏'
		},
		{
			id: '254',
			name: '贸易/进出口'
		},
		{
			id: '259',
			name: '办公用品及设备'
		},
		{
			id: '255',
			name: '批发/零售'
		},
		{
			id: '258',
			name: '服装/纺织/皮革'
		},
		{
			id: '288',
			name: '陶瓷卫浴'
		},
		{
			id: '289',
			name: '家具灯饰'
		},
		{
			id: '256',
			name: '快速消费品(食品/饮料等)'
		},
		{
			id: '257',
			name: '耐用消费品(家具/家电等)'
		},
		{
			id: '296',
			name: '租赁服务'
		},

		{
			id: '270',
			name: '建筑/建材'
		},
		{
			id: '271',
			name: '家居/室内设计/装潢'
		},
		{
			id: '260',
			name: '钢铁/机械/设备/重工'
		},
		{
			id: '268',
			name: '出版/印刷/造纸'
		},
		{
			id: '282',
			name: '原材料和加工'
		},
		{
			id: '263',
			name: '生物/制药/医疗器械'
		},
		{
			id: '248',
			name: '通信/电信'
		},
		{
			id: '247',
			name: 'IT服务/系统集成'
		},
		{
			id: '249',
			name: '电子技术/半导体/集成电路'
		},
		{
			id: '250',
			name: '仪器仪表/工业自动化'
		},
		{
			id: '264',
			name: '广告/创意'
		},
		{
			id: '265',
			name: '公关/市场推广/会展'
		},
		{
			id: '266',
			name: '文体/影视/艺术'
		},
		{
			id: '267',
			name: '媒体传播'
		},
		{
			id: '280',
			name: '化工/采掘/冶炼'
		},
		{
			id: '281',
			name: '能源(电力/水利/矿产'
		},
		{
			id: '284',
			name: '环保'
		},
		{
			id: '279',
			name: '航天/航空'
		},
		{
			id: '283',
			name: '政府/非盈利机构'
		},
		{
			id: '285',
			name: '农林牧渔'
		},
		{
			id: '286',
			name: '多元化集团'
		},
		{
			id: '273',
			name: '检测/认证'
		},
		{
			id: '274',
			name: '法律/法务'
		},
		{
			id: '294',
			name: '咨询/顾问'
		},
		{
			id: '287',
			name: '其他行业'
		}
	]
];

export default industryList;



// WEBPACK FOOTER //
// ./src/module/basic/util/industry.js